var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var CMSController = {
    /*****************************************************************************************************
        * Is using route "api/cms/projectStructureTemplates/{groupId}" and http method "GET" to call the back-end.
    
        * @param {string} groupId
        * @returns {ProjectStructureTemplateDownloadDto[]}
    ******************************************************************************************************/
    GetProjectStructureTemplates: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectStructureTemplates/{groupId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectStructureTemplates/template/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {ProjectStructureTemplateDownloadDto}
    ******************************************************************************************************/
    GetProjectStructureTemplate: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectStructureTemplates/template/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectStructureTemplates" and http method "POST" to call the back-end.
    
        * @param {ProjectStructureTemplateUploadDto} dto
        * @returns {ProjectStructureTemplateDownloadDto}
    ******************************************************************************************************/
    CreateProjectStructureTemplate: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectStructureTemplates", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectStructureTemplates/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {ProjectStructureTemplateUploadDto} dto
        * @returns {ProjectStructureTemplateDownloadDto}
    ******************************************************************************************************/
    UpdateProjectStructureTemplate: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectStructureTemplates/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectStructureTemplates/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    DeleteProjectStructureTemplate: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectStructureTemplates/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/members/{projectGroupId}" and http method "GET" to call the back-end.
    
        * @param {string} projectGroupId
        * @returns {UserShortInfoDownloadDto[]}
    ******************************************************************************************************/
    GetProjectGroupMembers: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/members/{projectGroupId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/members/{projectGroupId}/roles" and http method "GET" to call the back-end.
    
        * @param {string} projectGroupId
        * @returns {ExtendedDataCollection<RoleAssignment, UserShortInfoDownloadDto[]>}
    ******************************************************************************************************/
    GetProjectGroupMembersWithRoles: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/members/{projectGroupId}/roles", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/members/{projectGroupId}" and http method "POST" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {RoleAssignment[]} assignments
        * @returns {UserDownloadDto[]}
    ******************************************************************************************************/
    AssignProjectGroupRolesToUsers: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/members/{projectGroupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/members/{projectGroupId}/{userId}" and http method "DELETE" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {string} userId
        * @returns {UserShortInfoDownloadDto}
    ******************************************************************************************************/
    RemoveProjectGroupMember: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/members/{projectGroupId}/{userId}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/members/roles/{projectGroupId}/{userId}" and http method "GET" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {string} userId
        * @returns {string}
    ******************************************************************************************************/
    GetRolesOfProjectGroupMember: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/members/roles/{projectGroupId}/{userId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroups/createId" and http method "GET" to call the back-end.
    
        * @returns {string}
    ******************************************************************************************************/
    CreateProjectId: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroups/createId", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroups/minimalRole/{groupId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {Rights[]} rights
        * @returns {string[]}
    ******************************************************************************************************/
    GetMinimalProjectRole: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.rights !== undefined)
            fd.append("rights", JSON.stringify(data.rights));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroups/minimalRole/{groupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroups/zipProgress/{projectGroupId}" and http method "POST" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {string[]} path
        * @returns {ZipUploadInProgress[]}
    ******************************************************************************************************/
    GetZipProgresses: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.path !== undefined)
            fd.append("path", JSON.stringify(data.path));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroups/zipProgress/{projectGroupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroups/uploadZip/{projectId}/{progressId?}" and http method "POST" to call the back-end.
    
        * @param {string} projectId
        * @param {UploadZipToProject} upload
        * @param {string} progressId
        * @returns {ZipUploadInProgress}
    ******************************************************************************************************/
    UploadZipToProject: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("upload", JSON.stringify(data.upload));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroups/uploadZip/{projectId}/{progressId?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroups/tryUploadZip/{projectId}/{progressId?}" and http method "POST" to call the back-end.
    
        * @param {string} projectId
        * @param {UploadZipToProject} upload
        * @param {string} progressId
        * @returns {TryZipToProjectResponse}
    ******************************************************************************************************/
    TryUploadZipToProject: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("upload", JSON.stringify(data.upload));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroups/tryUploadZip/{projectId}/{progressId?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroups/zipContent" and http method "POST" to call the back-end.
    
        * @param {UploadZipToProject} upload
        * @returns {FileEntriesDownloadDto}
    ******************************************************************************************************/
    GetZipContent: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("upload", JSON.stringify(data.upload));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroups/zipContent", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroups/download/{projectId}/{fileEntryId}/{progressId?}" and http method "POST" to call the back-end.
    
        * @param {string} projectId
        * @param {string} fileEntryId
        * @param {FileEntrySelectContentDto[]} selection
        * @param {string} progressId
        * @returns {LinkDto}
    ******************************************************************************************************/
    DownloadProject: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("selection", JSON.stringify(data.selection));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroups/download/{projectId}/{fileEntryId}/{progressId?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroups/downloadOutput/{progressId?}/{doNotCleanZip?}" and http method "POST" to call the back-end.
    
        * @param {CMSDownloadPack[]} packs
        * @param {string} reason
        * @param {FileEntrySelectContentDto[]} selection
        * @param {string} progressId
        * @param {boolean} doNotCleanZip
        * @returns {void}
    ******************************************************************************************************/
    DownloadProjectOutput: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("packs", JSON.stringify(data.packs));
        fd.append("reason", JSON.stringify(data.reason));
        fd.append("selection", JSON.stringify(data.selection));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroups/downloadOutput/{progressId?}/{doNotCleanZip?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroups/preview/downloadOutput/{progressId?}/{doNotCleanZip?}" and http method "POST" to call the back-end.
    
        * @param {CMSDownloadPack[]} packs
        * @param {FileEntrySelectContentDto[]} selection
        * @param {string} progressId
        * @param {boolean} doNotCleanZip
        * @returns {PreviewDirectory}
    ******************************************************************************************************/
    PreviewDownloadProjectOutput: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("packs", JSON.stringify(data.packs));
        fd.append("selection", JSON.stringify(data.selection));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroups/preview/downloadOutput/{progressId?}/{doNotCleanZip?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroups/preview/output/{projectId}/{progressId?}" and http method "POST" to call the back-end.
    
        * @param {string} projectId
        * @param {string} progressId
        * @returns {PreviewDirectory}
    ******************************************************************************************************/
    PreviewProjectOutput: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroups/preview/output/{projectId}/{progressId?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroups/check/projectId/{groupId}/{projectId}/{id?}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} projectId
        * @param {string} id
        * @returns {boolean}
    ******************************************************************************************************/
    CheckProjectId: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroups/check/projectId/{groupId}/{projectId}/{id?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroup/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {ProjectGroupDownloadDto}
    ******************************************************************************************************/
    GetProjectGroup: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroup/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroup/info/{id}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {ProjectGroupInfoDownloadDto}
    ******************************************************************************************************/
    GetProjectGroupInfo: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroup/info/{id}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroups/byIds" and http method "POST" to call the back-end.
    
        * @param {string[]} ids
        * @returns {ProjectGroupDownloadDto[]}
    ******************************************************************************************************/
    GetProjectGroupsByIds: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("ids", JSON.stringify(data.ids));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroups/byIds", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroups" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @returns {ExtendedDataCollection<ProjectGroupDownloadDto, string>}
    ******************************************************************************************************/
    GetProjectGroups: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("token", JSON.stringify(data.token));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroups", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/output/projectGroups" and http method "POST" to call the back-end.
    
        * @param {TokenContainer} token
        * @param {FileEntrySearchFilter} feFilter
        * @param {FetchPostsFilter} filter
        * @returns {ExtendedDataCollection<ProjectGroupDownloadDto, string>}
    ******************************************************************************************************/
    GetOutputProjectGroups: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("token", JSON.stringify(data.token));
        if (data.feFilter !== undefined)
            fd.append("feFilter", JSON.stringify(data.feFilter));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/output/projectGroups", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroup/{groupId}/{structureTemplateId}" and http method "POST" to call the back-end.
    
        * @param {string} groupId
        * @param {string} structureTemplateId
        * @param {ProjectGroupUploadDto} dto
        * @param {string[]} workflowIds
        * @param {File} image
        * @param {RoleAssignment[]} roleAssignments
        * @returns {ProjectGroupDownloadDto}
    ******************************************************************************************************/
    CreateProjectGroup: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        fd.append("workflowIds", JSON.stringify(data.workflowIds));
        if (data.image)
            fd.append("image", data.image);
        if (data.roleAssignments !== undefined)
            fd.append("roleAssignments", JSON.stringify(data.roleAssignments));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroup/{groupId}/{structureTemplateId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroup/{projectGroupId}/{workflowId}/publish" and http method "POST" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {string} workflowId
        * @param {string[]} fileEntryFilter
        * @returns {void}
    ******************************************************************************************************/
    PublishProjectGroup: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.fileEntryFilter !== undefined)
            fd.append("fileEntryFilter", JSON.stringify(data.fileEntryFilter));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroup/{projectGroupId}/{workflowId}/publish", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroup/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {ProjectGroupUploadDto} dto
        * @param {string[]} workflowIds
        * @param {File} image
        * @param {RoleAssignment[]} roleAssignments
        * @returns {ProjectGroupDownloadDto}
    ******************************************************************************************************/
    ChangeProjectGroup: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("dto", JSON.stringify(data.dto));
        fd.append("workflowIds", JSON.stringify(data.workflowIds));
        if (data.image)
            fd.append("image", data.image);
        if (data.roleAssignments !== undefined)
            fd.append("roleAssignments", JSON.stringify(data.roleAssignments));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroup/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroup/{id}" and http method "DELETE" to call the back-end.
    
        * @param {string} id
        * @returns {ProjectGroupDownloadDto}
    ******************************************************************************************************/
    DeleteProjectGroup: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroup/{id}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroup/{id}/update/published" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {void}
    ******************************************************************************************************/
    UpdatePublishedProjectGroup: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroup/{id}/update/published", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroups/update/published" and http method "POST" to call the back-end.
    
        * @param {string[]} sourceGroupIds
        * @param {string[]} projectGroupIds
        * @returns {ProjectGroupDownloadDto[]}
    ******************************************************************************************************/
    UpdatePublishedProjectGroups: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.sourceGroupIds !== undefined)
            fd.append("sourceGroupIds", JSON.stringify(data.sourceGroupIds));
        if (data.projectGroupIds !== undefined)
            fd.append("projectGroupIds", JSON.stringify(data.projectGroupIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroups/update/published", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/projectGroups/recreate/thumbnails/{projectId}" and http method "POST" to call the back-end.
    
        * @param {string} projectId
        * @returns {void}
    ******************************************************************************************************/
    RecreateFileThumbnailsForProject: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/projectGroups/recreate/thumbnails/{projectId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/undelete/{fileId}" and http method "POST" to call the back-end.
    
        * @param {string} fileId
        * @returns {void}
    ******************************************************************************************************/
    UndeleteFile: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/undelete/{fileId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/{fileEntryId}/disjoints" and http method "GET" to call the back-end.
    
        * @param {string} fileEntryId
        * @returns {FileEntryWithPath[]}
    ******************************************************************************************************/
    GetDisjointFiles: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/{fileEntryId}/disjoints", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/{fileEntryId}/join/{fromId}" and http method "POST" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {string} fromId
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    JoinFiles: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/{fileEntryId}/join/{fromId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/{projectGroupId}" and http method "GET" to call the back-end.
    
        * @param {string} projectGroupId
        * @returns {FileEntryDownloadDto[]}
    ******************************************************************************************************/
    GetFiles: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/{projectGroupId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/{projectGroupId}" and http method "POST" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {TokenContainer} token
        * @param {string[]} path
        * @returns {ExtendedDataCollection<FileEntryDownloadDto, string>}
    ******************************************************************************************************/
    GetFilesPartial: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("token", JSON.stringify(data.token));
        if (data.path !== undefined)
            fd.append("path", JSON.stringify(data.path));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/{projectGroupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/recreate/thumbs/{fileId}" and http method "GET" to call the back-end.
    
        * @param {string} fileId
        * @returns {void}
    ******************************************************************************************************/
    RecreateThumbsFor: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/recreate/thumbs/{fileId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/output/locationsAndLanguages/{projectGroupId}" and http method "GET" to call the back-end.
    
        * @param {string} projectGroupId
        * @returns {ExtendedDataCollection<string, string[]>}
    ******************************************************************************************************/
    GetOutputFilesLocationIdsAndLanguages: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/output/locationsAndLanguages/{projectGroupId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/output/locationsAndLanguagesPacked/{projectGroupId}" and http method "GET" to call the back-end.
    
        * @param {string} projectGroupId
        * @returns {FileEntrySelectContentDto[]}
    ******************************************************************************************************/
    GetOutputFilesLocationIdsAndLanguagesPacked: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/output/locationsAndLanguagesPacked/{projectGroupId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/output/locationsAndLanguagesPacked/{projectGroupId}" and http method "POST" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {string[]} fileIds
        * @returns {FileEntrySelectContentDto[]}
    ******************************************************************************************************/
    GetOutputLocationIdsAndLanguagesForFile: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("fileIds", JSON.stringify(data.fileIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/output/locationsAndLanguagesPacked/{projectGroupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/media/{projectGroupId}" and http method "POST" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {string} path
        * @param {string} contentPostLocationId
        * @param {MediaUploadDto} data
        * @param {boolean | null} isProjectOutput
        * @param {string[]} categoryIds
        * @param {string} comment
        * @param {boolean | null} useSimpleFileName
        * @param {boolean | null} silent
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    AddMediaFile: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("path", JSON.stringify(data.path));
        fd.append("contentPostLocationId", JSON.stringify(data.contentPostLocationId));
        fd.append("data", JSON.stringify(data.data));
        if (data.isProjectOutput !== undefined)
            fd.append("isProjectOutput", JSON.stringify(data.isProjectOutput));
        if (data.categoryIds !== undefined)
            fd.append("categoryIds", JSON.stringify(data.categoryIds));
        if (data.comment !== undefined)
            fd.append("comment", JSON.stringify(data.comment));
        if (data.useSimpleFileName !== undefined)
            fd.append("useSimpleFileName", JSON.stringify(data.useSimpleFileName));
        if (data.silent !== undefined)
            fd.append("silent", JSON.stringify(data.silent));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/media/{projectGroupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/simplify" and http method "POST" to call the back-end.
    
        * @param {string} path
        * @param {UploadWithSimplifyPatternsForFileName} simplifyPatterns
        * @returns {string}
    ******************************************************************************************************/
    SimplifyFileName: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("path", JSON.stringify(data.path));
        if (data.simplifyPatterns !== undefined)
            fd.append("simplifyPatterns", JSON.stringify(data.simplifyPatterns));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/simplify", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/check/exists/{projectGroupId}" and http method "POST" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {string} path
        * @param {string} mediaType
        * @returns {string}
    ******************************************************************************************************/
    CheckFileName: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("path", JSON.stringify(data.path));
        fd.append("mediaType", JSON.stringify(data.mediaType));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/check/exists/{projectGroupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/content/{fileEntryId}" and http method "DELETE" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {FileEntrySelectContentDto[]} toDelete
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    DeleteFileEntryContent: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("toDelete", JSON.stringify(data.toDelete));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/content/{fileEntryId}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/changeReferenceToCopy/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {LanguageStringUploadDto[]} reason
        * @param {string} comment
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    ChangeReferenceToCopy: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("reason", JSON.stringify(data.reason));
        if (data.comment !== undefined)
            fd.append("comment", JSON.stringify(data.comment));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/changeReferenceToCopy/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/files/copyReference/{projectGroupId}" and http method "POST" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {string[]} ids
        * @param {string} path
        * @param {string} comment
        * @returns {ProjectGroupDownloadDto}
    ******************************************************************************************************/
    AddCopyReferenceFiles: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("ids", JSON.stringify(data.ids));
        fd.append("path", JSON.stringify(data.path));
        if (data.comment !== undefined)
            fd.append("comment", JSON.stringify(data.comment));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/files/copyReference/{projectGroupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/deleteReference/{id}" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    DeleteCopyReferenceFile: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/deleteReference/{id}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/media/{fileEntryId}" and http method "PATCH" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {string} contentPostLocationId
        * @param {MediaUploadDto} data
        * @param {string[]} categoryIds
        * @param {string} comment
        * @param {boolean | null} useSimpleFileName
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    UpdateMediaFile: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("contentPostLocationId", JSON.stringify(data.contentPostLocationId));
        fd.append("data", JSON.stringify(data.data));
        if (data.categoryIds !== undefined)
            fd.append("categoryIds", JSON.stringify(data.categoryIds));
        if (data.comment !== undefined)
            fd.append("comment", JSON.stringify(data.comment));
        if (data.useSimpleFileName !== undefined)
            fd.append("useSimpleFileName", JSON.stringify(data.useSimpleFileName));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/media/{fileEntryId}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/preview/{fileEntryId}" and http method "PATCH" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {MediaUploadDto} data
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    UpdateFileEntryPreviewImage: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.data !== undefined)
            fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/preview/{fileEntryId}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/duration/{fileEntryId}" and http method "PATCH" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {number} durationInMins
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    UpdateFileEntryDuration: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("durationInMins", JSON.stringify(data.durationInMins));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/duration/{fileEntryId}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/move/{fileEntryId}" and http method "PATCH" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {string} path
        * @returns {ProjectGroupDownloadDto}
    ******************************************************************************************************/
    MoveEntry: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("path", JSON.stringify(data.path));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/move/{fileEntryId}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/files/move" and http method "PATCH" to call the back-end.
    
        * @param {string[]} fileEntryIds
        * @param {string} path
        * @returns {ProjectGroupDownloadDto}
    ******************************************************************************************************/
    MoveEntries: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("fileEntryIds", JSON.stringify(data.fileEntryIds));
        fd.append("path", JSON.stringify(data.path));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/files/move", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/reference/{projectGroupId}" and http method "POST" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {string} path
        * @param {string} contentPostLocationId
        * @param {string} referenceId
        * @param {boolean | null} isProjectOutput
        * @param {string[]} categoryIds
        * @param {string} comment
        * @param {boolean | null} useSimpleFileName
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    AddMediaReference: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("path", JSON.stringify(data.path));
        fd.append("contentPostLocationId", JSON.stringify(data.contentPostLocationId));
        fd.append("referenceId", JSON.stringify(data.referenceId));
        if (data.isProjectOutput !== undefined)
            fd.append("isProjectOutput", JSON.stringify(data.isProjectOutput));
        if (data.categoryIds !== undefined)
            fd.append("categoryIds", JSON.stringify(data.categoryIds));
        if (data.comment !== undefined)
            fd.append("comment", JSON.stringify(data.comment));
        if (data.useSimpleFileName !== undefined)
            fd.append("useSimpleFileName", JSON.stringify(data.useSimpleFileName));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/reference/{projectGroupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/reference/{fileEntryId}" and http method "PATCH" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {string} contentPostLocationId
        * @param {string} referenceId
        * @param {string[]} categoryIds
        * @param {string} comment
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    UpdateMediaReference: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("contentPostLocationId", JSON.stringify(data.contentPostLocationId));
        fd.append("referenceId", JSON.stringify(data.referenceId));
        if (data.categoryIds !== undefined)
            fd.append("categoryIds", JSON.stringify(data.categoryIds));
        if (data.comment !== undefined)
            fd.append("comment", JSON.stringify(data.comment));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/reference/{fileEntryId}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/rename/{fileEntryId}" and http method "PATCH" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {string} newName
        * @param {string} comment
        * @param {boolean | null} useSimpleFileName
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    RenameFileEntry: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("newName", JSON.stringify(data.newName));
        if (data.comment !== undefined)
            fd.append("comment", JSON.stringify(data.comment));
        if (data.useSimpleFileName !== undefined)
            fd.append("useSimpleFileName", JSON.stringify(data.useSimpleFileName));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/rename/{fileEntryId}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/references/{fileEntryId}" and http method "GET" to call the back-end.
    
        * @param {string} fileEntryId
        * @returns {ExtendedDataCollection<FileEntryReferenceInfo, ProjectGroupDownloadDto[]>}
    ******************************************************************************************************/
    GetFileReferences: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/references/{fileEntryId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/children/{fileEntryId}" and http method "GET" to call the back-end.
    
        * @param {string} fileEntryId
        * @returns {FileEntryChildInfo[]}
    ******************************************************************************************************/
    GetChildren: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/children/{fileEntryId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/path/{fileEntryId}/{withFileName?}" and http method "GET" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {boolean} withFileName
        * @returns {string}
    ******************************************************************************************************/
    GetPathForFileEntry: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/path/{fileEntryId}/{withFileName?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/referenceOrigin/{fileEntryId}" and http method "GET" to call the back-end.
    
        * @param {string} fileEntryId
        * @returns {ExtendedDataCollection<FileEntryReferenceInfo, ProjectGroupDownloadDto[]>}
    ******************************************************************************************************/
    GetFileReferenceOrigin: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/referenceOrigin/{fileEntryId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/{fileEntryId}" and http method "DELETE" to call the back-end.
    
        * @param {string} fileEntryId
        * @returns {void}
    ******************************************************************************************************/
    DeleteContent: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/{fileEntryId}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/files" and http method "DELETE" to call the back-end.
    
        * @param {string[]} fileEntryIds
        * @returns {void}
    ******************************************************************************************************/
    DeleteContents: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("fileEntryIds", JSON.stringify(data.fileEntryIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/files", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/folder/add/{projectGroupId}" and http method "POST" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {string} path
        * @returns {string}
    ******************************************************************************************************/
    AddFolder: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("path", JSON.stringify(data.path));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/folder/add/{projectGroupId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/folder/rename/{projectGroupId}" and http method "PATCH" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {string} path
        * @param {string} newName
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    RenameFolder: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("path", JSON.stringify(data.path));
        fd.append("newName", JSON.stringify(data.newName));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/folder/rename/{projectGroupId}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/folder/delete/{projectGroupId}" and http method "DELETE" to call the back-end.
    
        * @param {string} projectGroupId
        * @param {string} path
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    DeleteFolder: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("path", JSON.stringify(data.path));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/folder/delete/{projectGroupId}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/{fileEntryId}/updated" and http method "POST" to call the back-end.
    
        * @param {string} fileEntryId
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    FileEntryTriggerUpdate: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/{fileEntryId}/updated", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/projectOutput/{fileEntryId}/{isProjectOutput}" and http method "PATCH" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {boolean} isProjectOutput
        * @param {string} workflowId
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    ChangeProjectOutput: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.workflowId !== undefined)
            fd.append("workflowId", JSON.stringify(data.workflowId));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/projectOutput/{fileEntryId}/{isProjectOutput}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/file/archived/{fileEntryId}/{isArchived}" and http method "PATCH" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {boolean} isArchived
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    ChangeArchived: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/file/archived/{fileEntryId}/{isArchived}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/files/archived/{isArchived}" and http method "PATCH" to call the back-end.
    
        * @param {string[]} fileEntryIds
        * @param {boolean} isArchived
        * @returns {FileEntryDownloadDto[]}
    ******************************************************************************************************/
    ChangeFilesArchived: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("fileEntryIds", JSON.stringify(data.fileEntryIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/files/archived/{isArchived}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/files/published/check" and http method "POST" to call the back-end.
    
        * @param {string[]} fileEntryIds
        * @returns {UsageTrackingDownloadDto[]}
    ******************************************************************************************************/
    CheckUnpublishFiles: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("fileEntryIds", JSON.stringify(data.fileEntryIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/files/published/check", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/files/published/{fileEntryId}" and http method "DELETE" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {string[]} fileEntryIds
        * @returns {FileEntryDownloadDto[]}
    ******************************************************************************************************/
    UnpublishFiles: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("fileEntryIds", JSON.stringify(data.fileEntryIds));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/files/published/{fileEntryId}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/getUploadUrlWithContainer" and http method "POST" to call the back-end.
    
        * @param {string} mediaType
        * @param {string} fileName
        * @param {string} container
        * @returns {UploadMediaParametersDto}
    ******************************************************************************************************/
    GetUploadUriWithContainer: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.mediaType !== undefined)
            fd.append("mediaType", JSON.stringify(data.mediaType));
        if (data.fileName !== undefined)
            fd.append("fileName", JSON.stringify(data.fileName));
        if (data.container !== undefined)
            fd.append("container", JSON.stringify(data.container));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/getUploadUrlWithContainer", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/recreateFileThumbnails/{fileEntryId}" and http method "POST" to call the back-end.
    
        * @param {string} fileEntryId
        * @returns {void}
    ******************************************************************************************************/
    RecreateFileThumbnails: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/recreateFileThumbnails/{fileEntryId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * @remark Usable even if user is not logged in!
        * Is using route "api/cms/recreateFileThumbnailsCallback" and http method "POST" to call the back-end.
    
        * @param {CreateThumbnailQueueEntry} entry
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    RecreateFileThumbnailsCallback: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/recreateFileThumbnailsCallback", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.entry
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/batchRecreateFileThumbnails/{limit}/{reset?}/{force?}" and http method "POST" to call the back-end.
    
        * @param {number} limit
        * @param {boolean} reset
        * @param {boolean} force
        * @returns {void}
    ******************************************************************************************************/
    BatchRecreateFileThumbnails: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/batchRecreateFileThumbnails/{limit}/{reset?}/{force?}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/search/files/{admin}/{byFileName}" and http method "POST" to call the back-end.
    
        * @param {boolean} admin
        * @param {boolean} byFileName
        * @param {string} text
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @param {FileEntrySearchFilter} feFilter
        * @param {TokenContainer} token
        * @param {number | null} maxCount
        * @returns {SearchResultsDto<FileEntrySearchResultDto>}
    ******************************************************************************************************/
    SearchFiles: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("text", JSON.stringify(data.text));
        fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        if (data.feFilter !== undefined)
            fd.append("feFilter", JSON.stringify(data.feFilter));
        if (data.token !== undefined)
            fd.append("token", JSON.stringify(data.token));
        if (data.maxCount !== undefined)
            fd.append("maxCount", JSON.stringify(data.maxCount));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/search/files/{admin}/{byFileName}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/suggest/files/{admin}" and http method "POST" to call the back-end.
    
        * @param {boolean} admin
        * @param {string} text
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @param {FileEntrySearchFilter} feFilter
        * @param {TokenContainer} token
        * @param {number | null} maxCount
        * @returns {string[]}
    ******************************************************************************************************/
    SuggestFiles: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("text", JSON.stringify(data.text));
        fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        if (data.feFilter !== undefined)
            fd.append("feFilter", JSON.stringify(data.feFilter));
        if (data.token !== undefined)
            fd.append("token", JSON.stringify(data.token));
        if (data.maxCount !== undefined)
            fd.append("maxCount", JSON.stringify(data.maxCount));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/suggest/files/{admin}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/search/files" and http method "POST" to call the back-end.
    
        * @param {FileEntrySearchResultDto} toFill
        * @returns {FileEntrySearchResultDto}
    ******************************************************************************************************/
    FillFileSearchResult: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("toFill", JSON.stringify(data.toFill));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/search/files", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/search/projects" and http method "POST" to call the back-end.
    
        * @param {ProjectGroupSearch} toFill
        * @returns {ProjectGroupSearch}
    ******************************************************************************************************/
    FillProjectSearchResult: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("toFill", JSON.stringify(data.toFill));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/search/projects", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/search/projects/{admin}/{ordered}" and http method "POST" to call the back-end.
    
        * @param {boolean} admin
        * @param {boolean} ordered
        * @param {string} text
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @param {FileEntrySearchFilter} feFilter
        * @param {TokenContainer} token
        * @param {number | null} maxCount
        * @returns {SearchResultsDto<ProjectGroupSearch>}
    ******************************************************************************************************/
    SearchProjects: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("text", JSON.stringify(data.text));
        fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        if (data.feFilter !== undefined)
            fd.append("feFilter", JSON.stringify(data.feFilter));
        if (data.token !== undefined)
            fd.append("token", JSON.stringify(data.token));
        if (data.maxCount !== undefined)
            fd.append("maxCount", JSON.stringify(data.maxCount));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/search/projects/{admin}/{ordered}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/suggest/projects/{admin}" and http method "POST" to call the back-end.
    
        * @param {boolean} admin
        * @param {string} text
        * @param {string} lng
        * @param {FetchPostsFilter} filter
        * @param {FileEntrySearchFilter} feFilter
        * @param {TokenContainer} token
        * @param {number | null} maxCount
        * @returns {string[]}
    ******************************************************************************************************/
    SuggestProjects: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("text", JSON.stringify(data.text));
        fd.append("lng", JSON.stringify(data.lng));
        if (data.filter !== undefined)
            fd.append("filter", JSON.stringify(data.filter));
        if (data.feFilter !== undefined)
            fd.append("feFilter", JSON.stringify(data.feFilter));
        if (data.token !== undefined)
            fd.append("token", JSON.stringify(data.token));
        if (data.maxCount !== undefined)
            fd.append("maxCount", JSON.stringify(data.maxCount));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/suggest/projects/{admin}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/historyEntries/{id}/{fromVersion?}/{toVersion?}" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @param {number | null} fromVersion
        * @param {number | null} toVersion
        * @returns {HistoryEntryDownloadDto[]}
    ******************************************************************************************************/
    GetHistoryEntries: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/historyEntries/{id}/{fromVersion?}/{toVersion?}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/historyData/{entryId}" and http method "GET" to call the back-end.
    
        * @param {string} entryId
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    GetHistoryData: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/historyData/{entryId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/history/{entryId}" and http method "POST" to call the back-end.
    
        * @param {string} entryId
        * @returns {void}
    ******************************************************************************************************/
    SetCurrentHistoryEntry: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/history/{entryId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/useSimpleFileName/{fileEntryId}" and http method "POST" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {boolean} useSimpleFileName
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    UseSimpleFileName: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("useSimpleFileName", JSON.stringify(data.useSimpleFileName));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/useSimpleFileName/{fileEntryId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/languageStrings/{fileEntryId}/{which}" and http method "POST" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {LanguageStringUploadDto[]} strings
        * @param {string} which
        * @returns {FileEntryDownloadDto}
    ******************************************************************************************************/
    UpdateLanguageStrings: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("strings", JSON.stringify(data.strings));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/languageStrings/{fileEntryId}/{which}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/usageTracking/{fileEntryId}/{locationId}" and http method "POST" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {string} locationId
        * @param {UsageTrackingEntryUploadDto} uploadDto
        * @returns {void}
    ******************************************************************************************************/
    AddUsageTracking: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/usageTracking/{fileEntryId}/{locationId}", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: data.uploadDto
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/usageTracking/{fileEntryId}/{locationId}" and http method "DELETE" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {string} locationId
        * @param {UsageTrackingEntryUploadDto} uploadDto
        * @returns {void}
    ******************************************************************************************************/
    RemoveUsageTracking: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.uploadDto !== undefined)
            fd.append("uploadDto", JSON.stringify(data.uploadDto));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/usageTracking/{fileEntryId}/{locationId}", __assign({}, data)),
            method: "DELETE",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/usageTracking/{fileEntryId}" and http method "GET" to call the back-end.
    
        * @param {string} fileEntryId
        * @returns {UsageTrackingDownloadDto}
    ******************************************************************************************************/
    GetUsageTracking: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/usageTracking/{fileEntryId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
    /*****************************************************************************************************
        * Is using route "api/cms/usageTracking/{fileEntryId}/{systemId}" and http method "GET" to call the back-end.
    
        * @param {string} fileEntryId
        * @param {string} systemId
        * @returns {boolean}
    ******************************************************************************************************/
    GetUsageTrackingForSystem: function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/cms/usageTracking/{fileEntryId}/{systemId}", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=CMSController.js.map